import React, { useEffect, useMemo, useState } from "react";
import {
  Col,
  Row,
  Typography,
  Form,
  Input,
  Button,
  Layout,
  Select,
  Image,
  Modal,
  Skeleton,
  Switch,
  Card,
} from "antd";
import {
  CloseCircleOutlined,
  EditOutlined,
  DeleteOutlined,
  SaveOutlined,
} from "@ant-design/icons";
import { FaArrowLeft } from "react-icons/fa";
import { Get } from "../../config/api/get";
import { QUESTION, QUIZ, COURSE, LECTURES } from "../../config/constants/api";
import { useNavigate, useParams } from "react-router-dom";
import { useSelector } from "react-redux";
import { Post } from "../../config/api/post";
import { Put } from "../../config/api/put";
import swal from "sweetalert";
import Swal from "sweetalert2";
import { ImageUrl } from "../../helpers/Functions";
import { Delete } from "../../config/api";
import { AiFillDelete } from "react-icons/ai";
import { FaEdit } from "react-icons/fa";
import "../upcoming-lessons/upcoming-lessons.css";
import "../course-management/course-management.css";
import "./quiz-details.css";

const { Option } = Select;

const correctOptions = new Array(4)
  .fill("Option ")
  .map((val, ind) => val + (ind + 1));
const iconFontSize = 20;

function QuizAdd() {
  const navigate = useNavigate();
  const token = useSelector((state) => state.user.userToken);
  const [modalOpen, setModalOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [question, setQuestion] = useState(null);
  const [course, setCourse] = useState([]);
  const [editMode, setEditMode] = useState(false);
  const [questionArray, setQuestionArray] = useState(["MCQ"]);
  const [quiz, setQuiz] = useState(null);
  const { id } = useParams();
  const [form] = Form.useForm();
  const [students, setStudents] = useState(null);
  const [active, setActive] = useState(false);
  const [lectures, setLectures] = useState([]);

  useEffect(() => {
    getQuizById();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps
  useEffect(() => {
    if (quiz?.isEnabled) {
      setActive(true);
    } else {
      setActive(false);
    }
  }, [quiz]);
  useEffect(() => {
    if (quiz && editMode) {
      form.setFieldsValue({
        students: quiz.students?.map(
          (student) => student.firstName + " " + student.lastName
        ),
      });
      setStudents(quiz.students);
    }
  }, [quiz, form, editMode]);

  const getQuizById = async () => {
    setLoading(true);
    const res = await Get(`${QUIZ.getQuizById}${id}`, token, {
      limit: "100",
    });
    setQuiz(res.data.quiz);
    
    // Fetch lectures for the quiz's course
    if (res.data.quiz?.course?._id) {
      const lectureRes = await Get(`${LECTURES.getAllLecturesByCourse}${res.data.quiz.course._id}`, token);
      if (lectureRes.status) {
        setLectures(lectureRes?.data?.docs || []);
      }
    }
    
    setLoading(false);
  };
  useEffect(() => {
    getCourses();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const getCourses = async () => {
    setLoading(true);
    const res = await Get(`${COURSE.getAllCourses}`, token, {
      limit: "100",
    });

    setCourse(res.data.docs);
    setLoading(false);
  };

  const handleStatus = async () => {
    try {
      await Get(
        QUESTION.toggleStatus + "/" + question._id,
        token,
        {}
      );
      const newUser = { ...question };

      newUser.isActive = !question.isActive;
      setModalOpen(false);
      setQuestion(newUser);
    } catch (error) {
      console.log(error.message);
    }
  };
  const handleCourseChange = async (courseId) => {
    // Fetch enrolled students
    const res = await Get(`${COURSE.getEnrolledStudens}${courseId}`, token);
    if (res.status) {
      setStudents(res?.data?.students);
    }
    
    // Fetch lectures for the selected course
    const lectureRes = await Get(`${LECTURES.getAllLecturesByCourse}${courseId}`, token);
    if (lectureRes.status) {
      setLectures(lectureRes?.data?.docs || []);
    } else {
      setLectures([]);
    }
    
    // Reset the form fields
    form.setFieldsValue({ students: [], lecture: undefined });
  };

  const onFinish = (values) => {
    setLoading(true);
    let obj = { ...values, questions: [] };
    Post(QUIZ.updateQuiz + id, obj, token, null)
      .then((response) => {
        setLoading(false);
        if (response?.data?.status) {
          console.log(response?.data);

          swal("Success!", "Quiz Updated Successfully", "success");
          navigate(-1);

          setEditMode(false);
        } else {
          setLoading(false);
          swal("Oops!", response.data.message, "error");
        }
      })
      .catch((e) => {
        setLoading(false);
      });
  };

  const onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo);
    setLoading(false);
  };

  const addQuestion = (e) => { // eslint-disable-line no-unused-vars
    try {
      let { innerText } = e.target;
      let [, text] = innerText?.split(" ");
      setQuestionArray([...questionArray, text]);
    } catch (error) {
      console.log(error);
    }
  };

  const removeQuestion = (ind) => { // eslint-disable-line no-unused-vars
    try {
      let arr = [...questionArray];
      arr.splice(ind, 1);
      setQuestionArray(arr);
    } catch (error) {
      console.log(error);
    }
  };
  const onSelectChange = (checked) => {
    handleClick(!active);
  };
  const handleClick = (value) => {
    if (value) {
      Swal.fire({
        title: "System Alert!",
        text: "Are you sure you want to mark as Active?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#18377E",
        cancelButtonColor: "#d33",
        cancelButtonText: "No",
        confirmButtonText: "Yes",
        showCloseButton: true,
      }).then((result) => {
        if (result.isConfirmed) {
          changeStatus();
        }
      });
    } else {
      Swal.fire({
        title: "System Alert!",
        text: "Are you sure you want to mark as Inactive?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#18377E",
        cancelButtonColor: "#d33",
        cancelButtonText: "No",
        confirmButtonText: "Confirm",
        showCloseButton: true,
      }).then((result) => {
        if (result.isConfirmed) {
          changeStatus();
        }
      });
    }
  };
  const changeStatus = () => {
    Put(`${QUIZ.toggleQuiz}${id}`, token)
      .then((response) => {
        if (response?.status) {
          swal("System Alert!", response?.message, "success");
          getQuizById();
        }
      })
      .catch((err) => {
        let message = err?.response?.data?.message || err?.message;
        console.log(":::;", err);
        if (message) swal("Oops!", message, "error");
      });
  };
  // const [elRefs, setElRefs] = useState([])

  // setElRefs((val) =>
  // questionArray
  //     .map((_, i) => val[i] || createRef()),
  // );

  // console.log(elRefs[0]?.current)

  // const myRefs = useRef([]);

  // myRefs.current = questionArray.map((element, i) => myRefs.current[i] ?? createRef());

  // const myRefs = questionArray.map(() => useRef(null))

  // console.log("aaa", myRefs[0])

  // const btnRef = useRef(null)
  // console.log('a', btnRef)

  // const [enabledForm, setEnabledForm] = useState(questionArray?.length - 1)

  const enabledForm = useMemo(() => { // eslint-disable-line no-unused-vars
    return questionArray?.length - 1;
  }, [questionArray]);
  const deleteQuiz = async () => {
    Delete(QUIZ.deleteQuiz + id, token)
      .then((response) => {
        if (response?.status) {
          swal("Success!", "Quiz Deleted Successfully", "success");
          navigate("/quiz-management");
        } else {
          swal("Oops!", response?.message, "error");
        }
      })
      .catch((e) => {
        const message = e?.response?.data?.message || e?.message;
        if (message) {
          swal("Oops!", message, "error");
        }
      });
  };
  return (
    <Layout
      className="configuration upcoming-lessons-page quiz-details-page"
      style={{ minHeight: "100vh" }}
    >
      <Row className="blueBackground-old coursebnr quiz-details-hero">
        <Typography.Title
          level={1}
          className="fontFamily1 aboutbanner-content"
          style={{color:"#fff"}}
        >
          Quiz details
        </Typography.Title>
      </Row>

      <div className="boxDetails2 quiz-details-shell">
        <Card className="quiz-details-top-card" bordered={false}>
          <Row gutter={[16, 16]} align="middle">
            <Col xs={24} md={16}>
              <div className="course-management-title-block">
                <button
                  type="button"
                  className="course-management-inline-back"
                  aria-label="Go back"
                  onClick={() => navigate(-1)}
                >
                  <FaArrowLeft aria-hidden="true" />
                </button>
                <Typography.Title
                  level={2}
                  className="fontFamily1 quiz-details-page-title"
                >
                  {editMode ? "Edit Quiz Details" : "View Quiz Details"}
                </Typography.Title>
              </div>
            </Col>
            <Col xs={24} md={8} className="quiz-details-top-actions">
              <Button
                onClick={deleteQuiz}
                type="default"
                danger
                className="quiz-details-delete-btn"
                icon={<AiFillDelete style={{ fontSize: 20 }} />}
              >
                Delete
              </Button>
            </Col>
          </Row>
        </Card>

        {loading && (
          <div className="quiz-details-skeleton-wrap">
            <Skeleton active paragraph={{ rows: 10 }} />
          </div>
        )}
        <div className="quiz-details-switch-row">
          <span className="quiz-details-switch-label">Quiz visibility</span>
          <Switch checked={active} onChange={onSelectChange} />
        </div>

        {!loading && quiz && (
          <>
            <div className="quiz-details-panel">
            <Form
              layout="vertical"
              name="basic"
              className="contactForm quiz-details-form"
              labelCol={{
                span: 0,
              }}
              wrapperCol={{
                span: 24,
              }}
              initialValues={{
                remember: true,
              }}
              onFinish={onFinish}
              onFinishFailed={onFinishFailed}
              autoComplete="off"
              form={form}
            >
              <Row style={{ padding: "20px" }} justify={"center"}>
                <Col xs={24} md={18}>
                  {editMode ? (
                    <>
                      <Row gutter={20}>
                        <Col xs={24} sm={12} className="quiz-details-field-col">
                          <Typography.Title
                            level={5}
                            className="fontFamily1 quiz-details-field-label"
                          >
                            Title :
                          </Typography.Title>

                          <Form.Item
                            name="title"
                            initialValue={quiz?.title}
                            style={{ width: "100%" }}
                            rules={[
                              {
                                required: true,
                                message: "Please input quiz title",
                              },
                            ]}
                          >
                            <Input
                              size="large"
                              placeholder="Enter Title"
                              className="signupFormInput"
                            />
                          </Form.Item>
                        </Col>
                        <Col xs={24} sm={12} className="quiz-details-field-col">
                          <Typography.Title
                            level={5}
                            className="fontFamily1 quiz-details-field-label"
                          >
                            Description:
                          </Typography.Title>

                          <Form.Item
                            name="description"
                            initialValue={quiz?.description}
                            style={{ width: "100%" }}
                            rules={[
                              {
                                required: true,
                                message: "Please input Quiz description",
                              },
                            ]}
                          >
                            <Input
                              size="large"
                              placeholder="Enter Description"
                              className="signupFormInput"
                            />
                          </Form.Item>
                        </Col>
                      </Row>

                      <Row gutter={20}>
                        <Col xs={24} sm={12} className="quiz-details-field-col">
                          <Typography.Title
                            level={5}
                            className="fontFamily1 quiz-details-field-label"
                          >
                            Course :
                          </Typography.Title>

                          <Form.Item
                            name="course"
                            initialValue={quiz?.course?._id}
                            style={{ width: "100%" }}
                            rules={[
                              {
                                required: true,
                                message: "Please input quiz course",
                              },
                            ]}
                          >
                            <Select
                              placeholder="Select Course"
                              className="signupSelectBox"
                              onChange={handleCourseChange}
                            >
                              {course.map((item) => {
                                return (
                                  <Option key={item._id} value={item._id}>
                                    {item?.title}
                                  </Option>
                                );
                              })}
                            </Select>
                          </Form.Item>
                        </Col>
                        <Col xs={24} sm={12} className="quiz-details-field-col">
                          <Typography.Title
                            level={5}
                            className="fontFamily1 quiz-details-field-label"
                          >
                            Lecture :
                          </Typography.Title>

                          <Form.Item
                            name="lecture"
                            initialValue={quiz?.lecture?._id}
                            style={{ width: "100%" }}
                            rules={[
                              {
                                required: true,
                                message: "Please select a lecture",
                              },
                            ]}
                          >
                            <Select
                              placeholder="Select Lecture"
                              className="signupSelectBox"
                            >
                              {lectures.map((item, index) => {
                                return (
                                  <Option key={item._id} value={item._id}>
                                    {item.title}
                                  </Option>
                                );
                              })}
                            </Select>
                          </Form.Item>
                        </Col>
                      </Row>

                      <Row gutter={20}>
                        <Col xs={24} sm={12} className="quiz-details-field-col">
                          <Typography.Title
                            level={5}
                            className="fontFamily1 quiz-details-field-label"
                          >
                            Passing Percent:
                          </Typography.Title>

                          <Form.Item
                            name="passingPercentage"
                            initialValue={quiz?.passingPercentage}
                            style={{ width: "100%" }}
                            rules={[
                              {
                                required: true,
                                message:
                                  "Please input Course passingPercentage",
                              },
                            ]}
                          >
                            <Input
                              size="large"
                              placeholder="Enter Passing Percent"
                              className="signupFormInput"
                            />
                          </Form.Item>
                        </Col>
                      </Row>

                      <Row gutter={20}>
                        <Col xs={24} sm={12} className="quiz-details-field-col">
                          <Typography.Title
                            level={5}
                            className="fontFamily1 quiz-details-field-label"
                          >
                            Select Students :
                          </Typography.Title>
                          <Form.Item name="students" style={{ width: "100%" }}>
                            {students && (
                              <Select
                                mode="multiple"
                                allowClear
                                style={{
                                  width: "100%",
                                }}
                                placeholder="Please select"
                                options={students.map((student) => ({
                                  label: `${student.firstName} ${student.lastName}`, // Display Name
                                  value: student._id, // Store _id on selection
                                }))}
                                className="custum-multiselect"
                              />
                            )}
                          </Form.Item>
                        </Col>
                      </Row>
                    </>
                  ) : (
                    <>
                      <div className="quiz-details-view-grid">
                        <Row gutter={[20, 20]}>
                          <Col xs={24} md={12} className="quiz-details-view-row">
                            <span className="quiz-details-view-label">Title</span>
                            <p className="quiz-details-view-value">{quiz?.title}</p>
                          </Col>
                          <Col xs={24} md={12} className="quiz-details-view-row">
                            <span className="quiz-details-view-label">
                              Description
                            </span>
                            <p className="quiz-details-view-value">
                              {quiz?.description}
                            </p>
                          </Col>
                        </Row>
                        <Row gutter={[20, 20]}>
                          <Col xs={24} md={12} className="quiz-details-view-row">
                            <span className="quiz-details-view-label">Course</span>
                            <p className="quiz-details-view-value">
                              {quiz?.course?.title}
                            </p>
                          </Col>
                          <Col xs={24} md={12} className="quiz-details-view-row">
                            <span className="quiz-details-view-label">Lecture</span>
                            <p className="quiz-details-view-value">
                              {quiz?.lecture?.title || "N/A"}
                            </p>
                          </Col>
                        </Row>
                        <Row gutter={[20, 20]}>
                          <Col xs={24} md={12} className="quiz-details-view-row">
                            <span className="quiz-details-view-label">
                              Passing Percent
                            </span>
                            <p className="quiz-details-view-value">
                              {quiz?.passingPercentage}
                            </p>
                          </Col>
                          <Col xs={24} md={12} className="quiz-details-view-row">
                            <span className="quiz-details-view-label">Status</span>
                            <p className="quiz-details-view-value">
                              {quiz?.isEnabled ? "Active" : "Inactive"}
                            </p>
                          </Col>
                        </Row>
                      </div>

                      {/* <Row style={{ padding: "10px" }}>
                        <Col xs={24} md={12}>
                          <h5
                            style={{
                              display: "block",
                              fontSize: 16,
                              fontWeight: "bold",
                              marginBottom: 10,
                            }}
                          >
                            Due Date
                          </h5>
                          <h5
                            style={{
                              display: "block",
                              fontSize: 16,
                              color: "#7a7e7f",
                              fontWeight: "normal",
                            }}
                          >
                            {dayjs(quiz?.quizDate).format("M/D/YYYY")}
                          </h5>
                        </Col>
                      </Row> */}
                    </>
                  )}

                  <div className="quiz-details-form-actions">
                    {editMode && (
                      <>
                        <Button
                          type="primary"
                          htmlType="submit"
                          size="large"
                          className="loginButton"
                        >
                          Save Changes
                        </Button>
                        <Button
                          className="fontFamily1 quiz-details-cancel"
                          size="large"
                          onClick={(e) => {
                            e.preventDefault();
                            setEditMode(false);
                          }}
                        >
                          Cancel
                        </Button>
                      </>
                    )}
                    {!editMode && (
                      <Button
                        type="primary"
                        htmlType="button"
                        size="large"
                        className="loginButton"
                        onClick={() => setEditMode(true)}
                      >
                        Edit Quiz
                      </Button>
                    )}
                  </div>
                </Col>
              </Row>
            </Form>
            </div>
            <Row
              className="quiz-details-questions-section"
              style={{ padding: "12px 0 20px", backgroundColor: "transparent" }}
              justify={"center"}
            >
              <Col xs={24} md={18}>
                <Row justify={"end"} gutter={[10, 10]} className="quiz-details-question-toolbar">
                  <Col style={{ textAlign: "center" }}>
                    <Button
                      type="primary"
                      htmlType="button"
                      className="loginButton"
                      onClick={() => navigate(`/quiz/${id}/add-question`)}
                    >
                      Add Question
                    </Button>
                  </Col>
                  <Col style={{ textAlign: "center" }}>
                    <Button
                      type="primary"
                      htmlType="button"
                      className="loginButton"
                      onClick={() => navigate(`/quiz/${id}/add-questions-bulk`)}
                    >
                      Add in Bulk
                    </Button>
                  </Col>
                </Row>
                <Row gutter={[16, 16]}>
                  {quiz?.questions?.map((val, qIdx) => (
                    <Col xs={24} key={val._id ?? `quiz-q-${qIdx}`}>
                      <Question question={val} />
                    </Col>
                  ))}
                </Row>
              </Col>
            </Row>
          </>
        )}
        <br />
        <br />
      </div>

      <Modal
        open={modalOpen}
        onOk={() => handleStatus()}
        onCancel={() => setModalOpen(false)}
        okText="Yes"
        className="StyledModal"
        style={{
          left: 0,
          right: 0,
          marginLeft: "auto",
          marginRight: "auto",
          textAlign: "center",
        }}
        cancelText="No"
        cancelButtonProps={{
          style: {
            border: "2px solid #2484c6",
            color: "#2484c6",
            height: "auto",
            padding: "6px 35px",
            borderRadius: "50px",
            fontSize: "16px",
            marginTop: "15px",
          },
        }}
        okButtonProps={{
          style: {
            backgroundColor: "#2484c6",
            color: "white",
            marginTop: "15px",
            height: "auto",
            padding: "5px 35px",
            borderRadius: "50px",
            fontSize: "16px",
            border: "2px solid #2484c6",
          },
        }}
      >
        <Image
          // src="../images/question.png"
          src={ImageUrl("question.png")}
          preview={false}
          width={100}
          height={120}
        />
        <Typography.Title level={4} style={{ fontSize: "25px" }}>
          {quiz?.isActive ? "Deactivate" : "Activate"}
        </Typography.Title>
        <Typography.Text style={{ fontSize: 16 }}>
          Do You Want To {quiz?.isActive ? "Deactivate" : "Activate"} This User?
        </Typography.Text>
      </Modal>

      <br />
      <br />
    </Layout>
  );
}
export default QuizAdd;

const Question = ({ question }) => {
  const token = useSelector((state) => state.user.userToken);
  const navigate = useNavigate();
  const { id } = useParams();
  // const question = {
  //   title: "Question 1",
  //   options: ["Option A", "Option B", "Option C", "Option D"],
  //   correctOption: "Option A",
  //   score: 10,
  //   quiz: "60a1a2b27b1c1322e8f12345"
  // }
  function deleteQuestion(id) {
    try {
      debugger;
      // setLoading(true);
      Post(QUESTION.deleteQuestion + id, {}, token, null)
        .then((response) => {
          // setLoading(false);
          if (response?.data?.status) {
            swal("Success!", "Question Deleted Successfully", "success");
          } else {
            swal("Oops!", response.data.message, "error");
          }
        })
        .catch((e) => {
          // setLoading(false);
        });
    } catch (error) {
      console.log(error);
    }
  }

  return (
    <article className="quiz-details-question-card">
      <div className="quiz-details-question-meta">
        Question type:{" "}
        {question?.type === "TRUE_FALSE"
          ? "True / False"
          : question?.type === "FILL_IN_THE_BLANKS"
          ? "Fill In the blanks"
          : "Mcq"}
      </div>
      <div className="quiz-details-question-title-bar">{question?.title}</div>
      <Row className="quiz-details-question-body" gutter={[16, 16]}>
        <Col xs={24} lg={17}>
          {question?.type === "MCQ" && (
            <div style={{ width: "100%" }}>
              {question?.options?.map((val, ind) => (
                <Typography.Title
                  key={`opt-${ind}`}
                  level={5}
                  className="fontFamily1 quiz-details-option-line"
                >
                  {`Option ${ind + 1}: ${val}`}
                </Typography.Title>
              ))}
            </div>
          )}
          {question?.correctOption && question.type !== "FILL_IN_THE_BLANKS" && (
            <div>
              <Typography.Title
                level={5}
                className="fontFamily1 quiz-details-option-line"
              >
                {`Correct Option: ${question?.correctOption}`}
              </Typography.Title>
            </div>
          )}
          {question?.correctAnswer &&
            question.type === "FILL_IN_THE_BLANKS" && (
              <div>
                <Typography.Title
                  level={5}
                  className="fontFamily1 quiz-details-option-line"
                >
                  {`Correct Answer: ${question?.correctAnswer}`}
                </Typography.Title>
              </div>
            )}
        </Col>
      </Row>
      <div className="quiz-details-question-footer">
        <Typography.Title level={5} className="quiz-details-question-score">
          {`Score: ${question?.score}`}
        </Typography.Title>
        <div className="quiz-details-question-icon-actions">
          <Button
            type="default"
            aria-label="Delete question"
            icon={<DeleteOutlined style={{ fontSize: iconFontSize }} />}
            onClick={() => deleteQuestion(question?._id)}
          />
          <Button
            type="default"
            aria-label="Edit question"
            icon={<FaEdit style={{ fontSize: iconFontSize }} />}
            onClick={() => {
              navigate(`/quiz/${question?._id}/edit-question`, {
                state: { questionDetails: question, quizId: id },
              });
            }}
          />
        </div>
      </div>
    </article>
  );
};

const QuestionForm = (props) => { // eslint-disable-line no-unused-vars
  const disabled = props.enabledForm !== props.ind; // eslint-disable-line no-unused-vars

  const onFinish = (e) => { // eslint-disable-line no-unused-vars
    console.log(e);
  };
  return (
    <Form
      name={`form${props.ind + 1}`}
      // onFinish={onFinish}
      //  onFinishFailed={onFinishFailed}
    >
      <Row style={{ padding: "20px", backgroundColor: "" }}>
        <Col xs={24} md={18}>
          <Row justify={"end"}>
            <Col style={{ display: "flex", gap: 10 }}>
              {disabled ? (
                <Button>
                  <EditOutlined
                    style={{ cursor: "pointer", fontSize: iconFontSize }}
                  />
                </Button>
              ) : (
                <>
                  <Button htmlType="submit">
                    <SaveOutlined
                      style={{ cursor: "pointer", fontSize: iconFontSize }}
                    />
                  </Button>
                </>
              )}
              <Button>
                <CloseCircleOutlined
                  style={{ cursor: "pointer", fontSize: iconFontSize }}
                  onClick={() => {
                    props.removeQuestion(props.ind);
                  }}
                />
              </Button>
            </Col>
          </Row>
          <Row gutter={20}>
            <Col xs={24} className="quiz-details-field-col">
              <Typography.Title
                level={5}
                className="fontFamily1 quiz-details-field-label"
              >
                Question :
              </Typography.Title>

              <Form.Item
                name={`title${props.ind}`}
                style={{ width: "100%" }}
                rules={[
                  {
                    required: true,
                    message: "Please input Question",
                  },
                ]}
              >
                <Input
                  disabled={disabled}
                  size="large"
                  placeholder="Enter Question"
                  className="signupFormInput"
                />
              </Form.Item>
            </Col>
          </Row>

          <Row gutter={20}>
            <Col xs={24} sm={12} className="quiz-details-field-col">
              <Typography.Title
                level={5}
                className="fontFamily1 quiz-details-field-label"
              >
                Option 1:
              </Typography.Title>

              <Form.Item
                name="option1"
                style={{ width: "100%" }}
                rules={[
                  {
                    required: true,
                    message: "Please input Option",
                  },
                ]}
              >
                <Input
                  disabled={disabled}
                  size="large"
                  placeholder="Enter Option"
                  className="signupFormInput"
                />
              </Form.Item>
            </Col>
            <Col xs={24} sm={12} className="quiz-details-field-col">
              <Typography.Title
                level={5}
                className="fontFamily1 quiz-details-field-label"
              >
                Option 2:
              </Typography.Title>

              <Form.Item
                name="option2"
                style={{ width: "100%" }}
                rules={[
                  {
                    required: true,
                    message: "Please input Option",
                  },
                ]}
              >
                <Input
                  disabled={disabled}
                  size="large"
                  placeholder="Enter Option"
                  className="signupFormInput"
                />
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={20}>
            <Col xs={24} sm={12} className="quiz-details-field-col">
              <Typography.Title
                level={5}
                className="fontFamily1 quiz-details-field-label"
              >
                Option 3:
              </Typography.Title>

              <Form.Item
                name="option3"
                style={{ width: "100%" }}
                rules={[
                  {
                    required: true,
                    message: "Please input Option",
                  },
                ]}
              >
                <Input
                  disabled={disabled}
                  size="large"
                  placeholder="Enter Option"
                  className="signupFormInput"
                />
              </Form.Item>
            </Col>
            <Col xs={24} sm={12} className="quiz-details-field-col">
              <Typography.Title
                level={5}
                className="fontFamily1 quiz-details-field-label"
              >
                Option 4:
              </Typography.Title>

              <Form.Item
                name="option4"
                style={{ width: "100%" }}
                rules={[
                  {
                    required: true,
                    message: "Please input Option",
                  },
                ]}
              >
                <Input
                  disabled={disabled}
                  size="large"
                  placeholder="Enter Option"
                  className="signupFormInput"
                />
              </Form.Item>
            </Col>
          </Row>

          <Row gutter={20}>
            <Col xs={24} sm={12} className="quiz-details-field-col">
              <Typography.Title
                level={5}
                className="fontFamily1 quiz-details-field-label"
              >
                Correct Option :
              </Typography.Title>

              <Form.Item
                name="category"
                style={{ width: "100%" }}
                rules={[
                  {
                    required: true,
                    message: "Please select question category",
                  },
                ]}
              >
                <Select
                  disabled={disabled}
                  placeholder="Select Option"
                  className="signupSelectBox"
                >
                  {correctOptions.map((item, index) => {
                    return <Option value={item}>{item}</Option>;
                  })}
                </Select>
              </Form.Item>
            </Col>
          </Row>
        </Col>
      </Row>
    </Form>
  );
};

const MCQForm = (props) => { // eslint-disable-line no-unused-vars
  return (
    <>
      <Row style={{ padding: "20px", backgroundColor: "" }}>
        <Col xs={24} md={18}>
          <Row justify={"end"}>
            <Col style={{ display: "flex", gap: 10 }}>
              <EditOutlined
                style={{ cursor: "pointer" }}
                onClick={() => {
                  props.removeQuestion(props.ind);
                }}
              />
              <CloseCircleOutlined
                style={{ cursor: "pointer" }}
                onClick={() => {
                  props.removeQuestion(props.ind);
                }}
              />
            </Col>
          </Row>
          <Row gutter={20}>
            <Col xs={24} className="quiz-details-field-col">
              <Typography.Title
                level={5}
                className="fontFamily1 quiz-details-field-label"
              >
                Question :
              </Typography.Title>

              <Form.Item
                name="title"
                style={{ width: "100%" }}
                rules={[
                  {
                    required: true,
                    message: "Please input Question",
                  },
                ]}
              >
                <Input
                  size="large"
                  placeholder="Enter Question"
                  className="signupFormInput"
                />
              </Form.Item>
            </Col>
          </Row>

          <Row gutter={20}>
            <Col xs={24} sm={12} className="quiz-details-field-col">
              <Typography.Title
                level={5}
                className="fontFamily1 quiz-details-field-label"
              >
                Option 1:
              </Typography.Title>

              <Form.Item
                name="option1"
                style={{ width: "100%" }}
                rules={[
                  {
                    required: true,
                    message: "Please input Option",
                  },
                ]}
                initialValue={"Yes"}
              >
                <Input
                  size="large"
                  placeholder="Enter Option"
                  disabled
                  className="signupFormInput"
                />
              </Form.Item>
            </Col>
            <Col xs={24} sm={12} className="quiz-details-field-col">
              <Typography.Title
                level={5}
                className="fontFamily1 quiz-details-field-label"
              >
                Option 2:
              </Typography.Title>

              <Form.Item
                name="option2"
                initialValue={"No"}
                style={{ width: "100%" }}
                rules={[
                  {
                    required: true,
                    message: "Please input Option",
                  },
                ]}
              >
                <Input
                  size="large"
                  placeholder="Enter Option"
                  className="signupFormInput"
                  disabled
                />
              </Form.Item>
            </Col>
          </Row>

          <Row gutter={20}>
            <Col xs={24} sm={12} className="quiz-details-field-col">
              <Typography.Title
                level={5}
                className="fontFamily1 quiz-details-field-label"
              >
                Correct Option :
              </Typography.Title>

              <Form.Item
                name="category"
                style={{ width: "100%" }}
                rules={[
                  {
                    required: true,
                    message: "Please select question category",
                  },
                ]}
              >
                <Select placeholder="Select Option" className="signupSelectBox">
                  {correctOptions.slice(0, 2).map((item, index) => {
                    return <Option value={item}>{item}</Option>;
                  })}
                </Select>
              </Form.Item>
            </Col>
          </Row>
        </Col>
      </Row>
    </>
  );
};
